export default "__VITE_ASSET__ewoOGDm5__"